"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_NUMBER_OF_ITEMS = void 0;
const MAX_NUMBER_OF_ITEMS = exports.MAX_NUMBER_OF_ITEMS = 8;
//# sourceMappingURL=ComparisonBar.types.js.map